// FACEBOOK PAGE

$(document).ready(function () {
    resetFacebookPage();
    $(window).resize(function () {
        resetFacebookPage();
    });
});

function resetFacebookPage() {
    $(".js-facebook-page").each(function (index, element) {
        var element = $(element),
            elementWidth = Math.min(500, parseInt(element.width() || 0)),
            elementFBPage = element.find(".fb-page"),
            elementFBPageWidth = parseInt(elementFBPage.attr("data-width") || 0);

        if (elementWidth != elementFBPageWidth) {
            element.html(elementFBPage.attr("data-width", elementWidth));
        }
    });
}